module.exports = function getResource(label, vars = []) {
    const resources = {
        galleryActivity: 'Gallery Activity',
        photos: 'Photos',
        noPhotos: `${vars[0]} doesn’t have any photos yet.`,
        lovedPhotos: 'Loved Photos',
        noLovedPhotos: `${vars[0]} hasn’t loved any photos yet.`,
        exploreTheGallery: 'Explore the Gallery'
    };
    return resources[label];
};
